import rill from "rill";

import ensureUser from "../../middleware/ensure-user";

import ensureSetup from "../../middleware/ensure-setup";
import ensurePaid from "../../middleware/ensure-paid";
import ensureCoach from "../../middleware/ensure-coach";
import ensureCoachUpgrade from "../../middleware/ensure-coach-upgrade";

import getProgramEditor from "../athlete-portal/programs/program-editor.controller";
import getWorkout from "../athlete-portal/programs/workout.controller";
import getProgramOverview from "../athlete-portal/programs/program-overview/program-overview.controller";
import getProgramPreview from "../dashboard/program-library/program-preview.controller";
import getMealPlanEditor from "./edit-meal-plan/edit-meal-plan.controller";

import Athletes from "./athletes";
import AllTemplates from "./all-templates";
import Settings from "./settings";
import Store from "./store";
import Income from "./income";
import SubscriberList from "./subscriber-list";
import CoachingDashboard from "./coaching-dashboard";
import Tasks from "./tasks";
import ExerciseLibrary from "./exercise-library";
import MSBUniversity from "./msb-university";
import Widgets from "./widgets";
import CustomWorkflows from "./custom-workflows";
import Chat from "./chat";
import CommunityChat from "./community-chat";
import MasterFoodLibrary from "./master-food-library";
import PlanManager from "./plan-manager";
import { getUserToRequest } from "../dashboard/settings/manage-coaches/utils/manage-coaches-utils";
import MembershipList from "./membership-list";
import Notifications from "./notifications";
import Support from "./support";
import Services from "./services";
import loadActivityFeed from "../../middleware/loadActivityFeed";

const CoachingPortal = (app) => {
  app.get("/coaching-portal").at(
    "/coaching-portal/*",
    ensureUser,
    ensureCoach,
    ensureCoachUpgrade,
    ensurePaid,
    loadActivityFeed,
    rill()
      .get(ensureSetup)
      .use(({ load }, next) =>
        load("listNotifications", {
          limit: 10,
        }).then(next)
      )

      .setup((app) => {
        app.get("/", ({ req, res, locals }, next) => {
          const { activeUser, organizationOwner } = locals;
          const userToRequest = getUserToRequest(activeUser, organizationOwner);
          const coachOrganizationPermissions =
            locals?.activeUser?.organizationPermissions || [];

          // First look for the permissions that allow the coach to acces to the store -
          // - in the ORGANIZATION permissions
          // These are by now "Templates" and "PUSH"
          const organizationStorePermissions =
            locals?.organizationPermissions?.filter((permission) =>
              ["PUSH"].includes(permission.permission)
            ) || {};

          // Then, in the permisisons of the COACH, find the a permissions that matches with the ones that
          // allow the coach to access to the store
          const coachHasStoreAccess = locals?.activeUser?.organizationUserStatus
            ? organizationStorePermissions?.some((storePermission) =>
                coachOrganizationPermissions.includes(storePermission?._id)
              )
            : true;

          return res.redirect(
            userToRequest &&
              userToRequest.pushAccountInfo &&
              coachHasStoreAccess &&
              !(process.window && window?.innerWidth <= 960)
              ? "/coaching-portal/store"
              : "/coaching-portal/athletes"
          );
        });
      })
      .setup(Athletes)
      .setup(AllTemplates)
      .setup(Settings)
      .setup(Store)
      .setup(Chat)
      .setup(CommunityChat)
      .setup(MasterFoodLibrary)
      .setup(Income)
      .setup(SubscriberList)
      .setup(CoachingDashboard)
      .setup(Tasks)
      .setup(ExerciseLibrary)
      .setup(MSBUniversity)
      .setup(Widgets)
      .setup(CustomWorkflows)
      .setup(PlanManager)
      .setup(MembershipList)
      .setup(Notifications)
      .setup(Support)
      .setup(Services)
      .setup((app) => {
        app
          .get("/templates/program-overview/:cycleId", getProgramOverview)
          .get("/templates/program-preview/:cycleId", getProgramPreview)
          .get("/store/program-preview/:cycleId", getProgramPreview)
          .get("/templates/edit-program/:cycleId", getProgramEditor)
          .get("/store/edit-program/:cycleId", getProgramEditor)
          .get("/store/edit-program/:cycleId", getProgramEditor)
          .get("/templates/workout", getWorkout)
          .get("/templates/edit-meal-plan", getMealPlanEditor);
      })
  );
};

export default CoachingPortal;
